module.exports = __webpack_public_path__ + "img/checkbox-checked.828188f9.svg";